export enum EngagementAttributeTypesEnum {
    engagements,
    engagementRate,
    likes,
    comments,
    shares,
    views,
    quotes
}
